export default "__VITE_ASSET__052099d9__"